import {useState} from "react";

function ConvertFrom({onFormatChange}) {

    const [selected, setSelected] = useState("PNG");

    const selectStyle = {
        width: "100px",
        padding: "8px 14px",
        fontSize: "16px",
        border: "0.5px solid #cfcfcf",
        borderRadius: "6px",
        backgroundColor: "#393939",
        color: "#ffffff",
        outline: "none",
        cursor: "pointer"
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSelected(value);

        // Send selected format back to parent
        if (onFormatChange) {
            onFormatChange(value);
        }
    };

    return (
        <select style={selectStyle} className="custom-select" value={selected} onChange={handleChange}>
            <option value="JPG">JPG</option>
            <option value="PNG">PNG</option>
            <option value="WEBP">WEBP</option>
        </select>

    );
}

export default ConvertFrom;